<template>
    <b-modal ref="mdlPrescrizioneEserciziEdit" size="xl" no-close-on-backdrop dialog-class="sa-modal-full-height" @ok="onOk" @hidden="onHidden">
        <template #modal-title> <i class="fas fa-dumbbell mr-2"></i> Prescrizione Esercizi </template>

        <div class="sa-flexbox-pianificazione-modal p-3">
            <div class="mb-4">
                <b-row>
                    <b-col cols="6" md="6">
                        <label class="sa-label-data font-weight-bold">Data Inizio :</label>
                        <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataInizio" type="date"></date-picker>
                    </b-col>
                    <b-col cols="6" md="6">
                        <label class="sa-label-data font-weight-bold">Data Fine :</label>
                        <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="jsonData.dataFine" type="date"></date-picker>
                    </b-col>
                </b-row>
            </div>
            <div class="mb-4">
                <b-row>
                    <b-col cols="12" md="12">
                        <label class="sa-label-data font-weight-bold">Prescrizione Medica (Generale):</label>
                        <b-form-textarea v-model="jsonData.prescrizione" rows="3" placeholder="Scrivi qui la descrizione/prescrizione generale..."> </b-form-textarea>
                    </b-col>
                </b-row>
            </div>

            <!-- Body: Tabella Inserimento Esercizi -->
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.listaEsercizi" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            <span> {{ (currentPage - 1) * perPage + row.index + 1 }} </span>
                        </template>

                        <template v-slot:cell(categoriaVideo)="row">
                            <b-form-select v-if="row.index === 0" v-model="row.item.categoria" :options="videoCategoriaOptions" @change="onChangeCategoria(row.item)" value-field="value" text-field="text"></b-form-select>
                            <span v-else>
                                {{ row.item.categoria }}
                            </span>
                        </template>

                        <template v-slot:cell(video)="row">
                            <b-form-select v-if="row.index === 0" v-model="row.item.idVideo" :options="row.item.videoOptions" value-field="id" text-field="nome" @change="onChangeVideo(row.item)"></b-form-select>
                            <span v-else>{{ row.item.prescrizione }}</span>
                        </template>

                        <template v-slot:cell(serie)="row">
                            <b-form-input v-if="row.index === 0" v-model="row.item.serie" type="number" placeholder="Es. 3"></b-form-input>
                            <span v-else>{{ row.item.serie }}</span>
                        </template>

                        <template v-slot:cell(ripetizioni)="row">
                            <b-form-input v-if="row.index === 0" v-model="row.item.ripetizioni" placeholder="Es. 10" type="number"></b-form-input>
                            <span v-else>{{ row.item.ripetizioni }}</span>
                        </template>

                        <template v-slot:cell(riposo)="row">
                            <b-form-input v-if="row.index === 0" v-model="row.item.riposo" placeholder="Es. 60s" type="number"></b-form-input>
                            <span v-else>{{ row.item.riposo }}</span>
                        </template>

                        <template v-slot:cell(ripetizioniSettimanili)="row">
                            <b-form-input v-if="row.index === 0" v-model="row.item.ripetizioniSettimanili" type="number" placeholder="Es. 3"></b-form-input>
                            <span v-else>{{ row.item.ripetizioniSettimanili }}</span>
                        </template>

                        <template v-slot:cell(actions)="row">
                            <div class="d-flex justify-content-center align-items-center">
                                <!-- Pulsante Aggiungi (Solo per la prima riga di input) -->
                                <b-button v-if="row.index === 0" variant="outline-success" @click="onclickAggiungiEsercizio(row.index)" title="Aggiungi Esercizio">
                                    <i class="fas fa-plus"></i>
                                </b-button>

                                <!-- Pulsanti Info e Rimuovi (Per le righe salvate) -->
                                <template v-else>
                                    <b-button :variant="row.detailsShowing ? 'info' : 'outline-info'" class="mr-2" @click="onclickVisualizzaVideo(row)" :title="row.detailsShowing ? 'Chiudi Video' : 'Info Video'">
                                        <i class="fas" :class="row.detailsShowing ? 'fa-eye-slash text-white' : 'fa-info-circle'"></i>
                                    </b-button>

                                    <b-button variant="outline-danger" @click="onClickRimuoviEsercizio(row.index)" title="Rimuovi Esercizio">
                                        <i class="fas fa-trash"></i>
                                    </b-button>
                                </template>
                            </div>
                        </template>

                        <!-- SLOT: Dettagli Riga (Espansione per il video) -->
                        <template #row-details="row">
                            <b-card class="bg-light m-2 border-0 shadow-sm">
                                <b-row>
                                    <b-col cols="12" class="text-center py-3">
                                        <!-- Mostra il loader se il video sta ancora scaricando -->
                                        <div v-if="row.item.caricamentoVideo"><b-spinner small class="mr-2"></b-spinner> Caricamento video in corso...</div>

                                        <!-- Mostra il video una volta che il blob è pronto -->
                                        <div v-else-if="row.item.videoUrlBlob">
                                            <video :src="row.item.videoUrlBlob" controls style="max-width: 100%; max-height: 350px; border-radius: 8px"></video>
                                        </div>

                                        <!-- Fallback se non c'è video -->
                                        <div v-else class="text-muted">
                                            <i class="fas fa-video-slash fa-2x mb-2"></i><br />
                                            Nessun video disponibile per questo esercizio.
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </template>
                    </b-table>
                </div>
            </div>

            <!-- Footer: Indicazioni Generali (Opzionale) -->
            <div class="mt-4">
                <label class="sa-label-data font-weight-bold">Note aggiuntive (Opzionale):</label>
                <b-form-textarea v-model="jsonData.note" rows="2" placeholder="Aggiungi eventuali note..."></b-form-textarea>
            </div>
        </div>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../../../utility/UtilityMixin";

import DatePicker from "vue2-datepicker";
import axios from "axios";

export default {
    name: "RsaPazientePrescrizioneEserciziEditModal",
    mixins: [UtilityMixin],
    components: { DatePicker },
    props: {
        idPaziente: {
            type: String,
            default: function () {
                return null;
            },
        },
    },
    data() {
        return {
            jsonData: this.getEmptyData(),
            listKey: 0,
            pathresource: "/pazientemedicinadellosportprescrizione",
            pathresourceVideo: "/servizivideo",
            videoOptions: [{ id: null, nome: "- Seleziona Video -" }],
            videoCategoriaOptions: [],
            perPage: 10,
            currentPage: 1,
            fields: [
                { key: "categoriaVideo", label: "Categoria", thStyle: "width: auto;" },
                { key: "video", label: "video", thStyle: "width: auto;" },
                { key: "serie", label: "Serie", thStyle: "width: 80px;" },
                { key: "ripetizioni", label: "Ripetizioni", thStyle: "width: 100px;" },
                { key: "riposo", label: "Riposo", thStyle: "width: 120px;" },
                { key: "ripetizioniSettimanili", label: "Rip. Sett.", thStyle: "width: 100px;", thClass: "text-center", tdClass: "text-center" },
                { key: "actions", label: "", thStyle: "width: 120px;", thClass: "text-center", tdClass: "text-center" },
            ],
        };
    },
    computed: {
        isPrescrizioneValida() {
            return true;
        },
    },
    methods: {
        apriModaleConId(idPrescrizione) {
            if (!idPrescrizione) {
                this.show(null);
                return;
            }

            let url = process.env.VUE_APP_PATH_API + this.pathresource + "/" + idPrescrizione;

            axios
                .get(url)
                .then((response) => {
                    let datiRecuperati = response.data.data ? response.data.data : response.data;
                    this.show(datiRecuperati);
                })
                .catch((error) => {
                    console.error("Errore nel recupero della prescrizione:", error);
                    this.$bvToast.toast("Impossibile recuperare i dati della prescrizione dal server.", {
                        title: "Errore",
                        autoHideDelay: 4000,
                        variant: "danger",
                    });
                });
        },

        show(dataExistent = null) {
            if (dataExistent) {
                this.jsonData = JSON.parse(JSON.stringify(dataExistent));
                if (!this.jsonData.listaEsercizi) {
                    this.jsonData.listaEsercizi = [];
                }

                this.jsonData.listaEsercizi.forEach((ex) => {
                    if (!ex.videoOptions) {
                        this.$set(ex, "videoOptions", [{ id: null, nome: "- Seleziona Video -" }]);
                    }
                });
            } else {
                this.jsonData = this.getEmptyData();
            }

            this.jsonData.listaEsercizi.unshift({
                id: null,
                idPrescrizione: this.jsonData.id,
                idVideo: null,
                categoriaVideo: null,
                video: null,
                prescrizione: "",
                proprietario: null,
                serie: null,
                ripetizioni: null,
                riposo: null,
                ripetizioniSettimanili: null,
                categoria: null,
                nomeVideo: null,
                videoOptions: [{ id: null, nome: "- Seleziona Video -" }],
            });

            this.loadVideoCategorie();
            this.$refs.mdlPrescrizioneEserciziEdit.show();
        },

        getEmptyData() {
            return {
                id: null,
                prescrizione: null,
                note: null,
                idPaziente: this.idPaziente,
                listaEsercizi: [],
                dataInizio: new Date().getTime(),
                dataFine: null,
            };
        },

        onClickAggiungiEsercizio() {
            // Se esiste almeno una riga (la riga di input in posizione 0)
            if (this.jsonData.listaEsercizi.length > 0) {
                let rigaCorrente = this.jsonData.listaEsercizi[0];

                // CONTROLLO VALIDAZIONE: Verifica che tutti i campi siano stati inseriti
                if (!rigaCorrente.categoria || !rigaCorrente.idVideo || !rigaCorrente.serie || !rigaCorrente.ripetizioni || !rigaCorrente.riposo || !rigaCorrente.ripetizioniSettimanili) {
                    this.$bvToast.toast("Compila tutti i campi prima di aggiungere un nuovo esercizio.", {
                        title: "Campi Mancanti",
                        autoHideDelay: 4000,
                        variant: "warning",
                        solid: true,
                    });
                    return; // Blocca l'esecuzione se manca qualcosa
                }
            }

            // Se la validazione va a buon fine, procedi aggiungendo una nuova riga vuota
            this.jsonData.listaEsercizi.unshift({
                id: null,
                idPrescrizione: this.jsonData.id,
                idVideo: null,
                categoriaVideo: null,
                video: null,
                prescrizione: "",
                proprietario: null,
                serie: null,
                ripetizioni: null,
                riposo: null,
                ripetizioniSettimanili: null,
                categoria: null,
                nomeVideo: null,
                videoOptions: [{ id: null, nome: "- Seleziona Video -" }],
            });

            this.listKey++;
        },

        onClickRimuoviEsercizio(index) {
            this.jsonData.listaEsercizi.splice(index, 1);
            this.listKey++;
        },

        onOk(bvModalEvent) {
            bvModalEvent.preventDefault();

            if (!this.isPrescrizioneValida) {
                this.$bvToast.toast("Assicurati di aver inserito almeno un esercizio e di averne compilato il nome.", {
                    title: "Attenzione",
                    autoHideDelay: 4000,
                    variant: "warning",
                });
                return;
            }

            let data = this.preparaDatiPerSalvataggio(this.jsonData);
            this.saveResource(this.pathresource, data, this.saveResourceSuccess, null);
        },

        saveResourceSuccess() {
            this.$refs.mdlPrescrizioneEserciziEdit.hide();
        },

        onHidden() {
            this.jsonData = this.getEmptyData();
            this.$emit("afterSave");
        },

        loadVideoCategorie() {
            this.loadDataResources(this.pathresourceVideo, {}, this.resultResponseVideoCategorie, null);
        },

        resultResponseVideoCategorie(response) {
            this.videoCategoriaOptions = [];
            this.videoOptions = response.data.data.list;
            const categorie = [...new Set(response.data.data.list.map((item) => item.categoria))];
            this.videoCategoriaOptions = categorie.map((c) => ({
                value: c,
                text: c,
            }));
            this.videoCategoriaOptions.unshift({ value: null, text: "- Seleziona Categoria -" });
        },

        onChangeCategoria(value) {
            this.loadVideo(value);
        },

        loadVideo(item) {
            this.loadDataResources(
                this.pathresourceVideo,
                { categoria: item.categoria },
                (response) => {
                    let listaVideo = response.data.data.list;
                    listaVideo.unshift({ id: null, nome: "- Seleziona Video -" });

                    this.$set(item, "videoOptions", listaVideo);
                },
                null,
            );
        },

        onChangeVideo(item) {
            let selected = item.videoOptions.find((element) => element.id === item.idVideo);
            if (selected) {
                item.prescrizione = selected.nome;
                this.loadStreamVideo(selected.id, item);
            }
        },

        loadStreamVideo(id, item) {
            this.$set(item, "caricamentoVideo", true);
            let link = process.env.VUE_APP_PATH_API + this.pathresourceVideo + "/video/" + id;
            axios
                .get(link, { responseType: "blob" })
                .then((response) => {
                    let urlBlob = URL.createObjectURL(response.data);
                    this.$set(item, "videoUrlBlob", urlBlob);
                })
                .catch((error) => {
                    console.error("Errore nel caricamento del video:", error);
                })
                .finally(() => {
                    this.$set(item, "caricamentoVideo", false);
                });
        },

        onclickAggiungiEsercizio() {
            this.onClickAggiungiEsercizio();
        },

        onclickVisualizzaVideo(row) {
            row.toggleDetails();
        },

        preparaDatiPerSalvataggio(jsonDataOriginale) {
            const campiAmmessi = ["id", "idPrescrizione", "idVideo", "prescrizione", "proprietario", "ripetizioni", "ripetizioniSettimanili", "riposo", "serie", "createUser", "proprietario", "createDate", "updateDate"];

            let datiDaSalvare = JSON.parse(JSON.stringify(jsonDataOriginale));

            let eserciziValidi = datiDaSalvare.listaEsercizi.filter((ex) => ex.prescrizione && ex.prescrizione.trim() !== "");

            datiDaSalvare.listaEsercizi = eserciziValidi.map((esercizio) => {
                let esercizioPulito = {};

                campiAmmessi.forEach((campo) => {
                    esercizioPulito[campo] = esercizio[campo] !== undefined ? esercizio[campo] : null;
                });

                return esercizioPulito;
            });

            return datiDaSalvare;
        },
    },
};
</script>

<style scoped>
.sa-flexbox-pianificazione-modal {
    display: flex;
    flex-direction: column;
    height: 100%;
}
</style>
